export default __webpack_public_path__ + "static/8-d61ac0118bc3a43984bbd932c076dab4.png";